export const QUESTION_TYPES = {
  multipleChoice: 'questions/multiple_choice',
  freeResponse: 'questions/free_response',
  mcq: 'questions/multiple_choice',
  frq: 'questions/free_response',
};
